import { useQuery } from '@tanstack/react-query';
import { tokenApi } from '~endpoints/Token';
import { useWebView } from '@myrealtrip/device-detect';
import { tokenKeys } from '~queryKeys/tokenKeys';

interface Params {
  enabled?: boolean;
}
export default function useTokenQueryForWebView({ enabled }: Params = {}) {
  const { isWebView } = useWebView();

  return useQuery({
    queryKey: tokenKeys.webview(),
    queryFn: () => tokenApi.v1.webview(),
    enabled: typeof enabled === 'boolean' ? enabled : isWebView,
  });
}
